import React from 'react';
import { useContext } from 'react';
import { toast } from 'react-hot-toast';
import { AuthContext } from '../../Context/AuthProvider/AuthProvider';


const CreateResume = () => {
    const { user } = useContext(AuthContext);



    const handleSubmit = (event) => {
        event.preventDefault();
        const form = event.target;
        const name = form.name.value;
        const title = form.title.value;
        const phone = form.phone.value;
        const email = form.email.value;
        const github = form.github.value;
        const linkedin = form.linkedin.value;
        const portfolio = form.portfolio.value;
        const aboutme = form.aboutme.value;
        const experties = form.experties.value;
        const comfortable = form.comfortable.value;
        const frameworks = form.frameworks.value;
        const toolsandsoftware = form.toolsandsoftware.value;
        const projectname1 = form.projectname1.value;
        const projectname2 = form.projectname2.value;
        const projectname3 = form.projectname3.value;
        const projectspecification1 = form.projectspecification1.value;
        const projectspecification2 = form.projectspecification2.value;
        const projectspecification3 = form.projectspecification3.value;
        const bulletepoint1 = form.bulletepoint1.value;
        const bulletepoint11 = form.bulletepoint11.value;
        const bulletepoint111 = form.bulletepoint111.value;
        const bulletepoint2 = form.bulletepoint2.value;
        const bulletepoint22 = form.bulletepoint22.value;
        const bulletepoint222 = form.bulletepoint222.value;
        const bulletepoint3 = form.bulletepoint3.value;
        const bulletepoint33 = form.bulletepoint33.value;
        const bulletepoint333 = form.bulletepoint333.value;
        const livelink1 = form.livelink1.value;
        const livelink2 = form.livelink2.value;
        const livelink3 = form.livelink3.value;
        const clientrepolink1 = form.clientrepolink1.value;
        const clientrepolink2 = form.clientrepolink2.value;
        const clientrepolink3 = form.clientrepolink3.value;
        const serverrepositorylink1 = form.serverrepositorylink1.value;
        const serverrepositorylink2 = form.serverrepositorylink2.value;
        const serverrepositorylink3 = form.serverrepositorylink3.value;
        const language1 = form.language1.value;
        const language2 = form.language2.value;
        const languageexpert1 = form.languageexpert1.value;
        const languageexpert2 = form.languageexpert2.value;



        const project1 = {
            projectName: projectname1,
            projectSpeciality: projectspecification1,
            bulletepoint1: bulletepoint1,
            bulletepoint2: bulletepoint11,
            bulletepoint3: bulletepoint111,
            liveLink: livelink1,
            clientRepo: clientrepolink1,
            serverRepo: serverrepositorylink1
        }
        const project2 = {
            projectName: projectname2,
            projectSpeciality: projectspecification2,
            bulletepoint1: bulletepoint2,
            bulletepoint2: bulletepoint22,
            bulletepoint3: bulletepoint222,
            liveLink: livelink2,
            clientRepo: clientrepolink2,
            serverRepo: serverrepositorylink2
        }
        const project3 = {
            projectName: projectname3,
            projectSpeciality: projectspecification3,
            bulletepoint1: bulletepoint3,
            bulletepoint2: bulletepoint33,
            bulletepoint3: bulletepoint333,
            liveLink: livelink3,
            clientRepo: clientrepolink3,
            serverRepo: serverrepositorylink3
        }

        const projects = [
            project1,
            project2,
            project3
        ]



        const data = {
            name,
            title,
            phone,
            email,
            github,
            linkedin,
            portfolio,
            aboutme,
            experties,
            comfortable,
            frameworks,
            toolsandsoftware,
            language1,
            language2,
            languageexpert1,
            languageexpert2,
            projects



        }
        console.log(data)



        fetch('https://cv-builder-application-server.vercel.app/all-resume', {
            method: 'POST',
            headers: {
                'content-type': 'application/json'
            },
            body: JSON.stringify(data)
        })
            .then(res => res.json())
            .then(result => {
                if (result.acknowledged) {
                    toast.success('Your Data has Recorded');

                }

            })
            .catch(error => {
                console.error(error.message);

            })



    }









    return (
        <div className='container mx-auto  xl:px-32 bg-gray-800 py-20'>
            <div className="">
                <form onSubmit={handleSubmit} className="  2xl:mx-auto 2xl:container md:flex items-center justify-center">

                    <div className="bg-white p-10 shadow-lg rounded  w-full  sm:px-6   ">
                        <h2 className='text-center text-3xl my-5 font-semibold'>Fillup this Form</h2>


                        <div className='flex gap-10'>
                            <div className="mt-6 md:w-1/2">
                                <label htmlFor="name" className="text-sm font-medium leading-none text-gray-800">
                                    {" "}
                                    Your Full Name{" "}
                                </label>
                                <input name='name' id="name" aria-labelledby="name" type="text" className="bg-gray-200 border rounded text-xs font-medium leading-none placeholder-gray-800 text-gray-800 py-3 w-full pl-3 mt-2 " placeholder="e.g: Md Shijan Ali " required />
                            </div>

                            <div className="mt-6 md:w-1/2">
                                <label htmlFor="title" className="text-sm font-medium leading-none text-gray-800">
                                    {" "}
                                    Title{" "}
                                </label>
                                <input name='title' id="title" aria-labelledby="title" type="text" className="bg-gray-200 border rounded text-xs font-medium leading-none placeholder-gray-800 text-gray-800 py-3 w-full pl-3 mt-2 " placeholder="e.g: Web Developer " required />
                            </div>
                        </div>


                        <div className='flex gap-10'>
                            <div className="mt-6 md:w-1/2">
                                <label htmlFor="phone" className="text-sm font-medium leading-none text-gray-800">
                                    {" "}
                                    Phone{" "}
                                </label>
                                <input name="phone" id="phone" aria-labelledby="phone" type="number" className="bg-gray-200 border rounded text-xs font-medium leading-none placeholder-gray-800 text-gray-800 py-3 w-full pl-3 mt-2 " placeholder="e.g: +880 1571261165 " required />
                            </div>

                            <div className="mt-6 w-1/2">
                                <label htmlFor="email" className="text-sm font-medium leading-none text-gray-800">
                                    {" "}
                                    Email{" "}
                                </label>
                                <input name='email' id="email" aria-labelledby="email" type="email" className="bg-gray-200 border rounded text-xs font-medium leading-none placeholder-gray-800 text-gray-800 py-3 w-full pl-3 mt-2" defaultValue={user?.email} disabled required />
                            </div>


                        </div>


                        <div className='flex gap-10'>
                            <div className="mt-6 md:w-1/3">
                                <label htmlFor="github" className="text-sm font-medium leading-none text-gray-800">
                                    {" "}
                                    Github Link{" "}
                                </label>
                                <input name="github" id="github" aria-labelledby="github" type="text" className="bg-gray-200 border rounded text-xs font-medium leading-none placeholder-gray-800 text-gray-800 py-3 w-full pl-3 mt-2 " placeholder=" " required />
                            </div>
                            <div className="mt-6 md:w-1/3">
                                <label htmlFor="linkedin" className="text-sm font-medium leading-none text-gray-800">
                                    {" "}
                                    Linkedin Link{" "}
                                </label>
                                <input name="linkedin" id="linkedin" aria-labelledby="linkedin" type="text" className="bg-gray-200 border rounded text-xs font-medium leading-none placeholder-gray-800 text-gray-800 py-3 w-full pl-3 mt-2 " placeholder=" " required />
                            </div>
                            <div className="mt-6 md:w-1/3">
                                <label htmlFor="portfolio" className="text-sm font-medium leading-none text-gray-800">
                                    {" "}
                                    Portfolio Link{" "}
                                </label>
                                <input name="portfolio" id="portfolio" aria-labelledby="portfolio" type="text" className="bg-gray-200 border rounded text-xs font-medium leading-none placeholder-gray-800 text-gray-800 py-3 w-full pl-3 mt-2 " placeholder=" " required />
                            </div>




                        </div>

                        <div>
                            <div className="mt-6 w-full">
                                <label htmlFor="aboutme" className="text-sm font-medium leading-none text-gray-800">
                                    {" "}
                                    About Yourself{" "}
                                </label>
                                <textarea maxLength={300} name="aboutme" id="aboutme" aria-labelledby="aboutme" className="textarea textarea-bordered bg-gray-200 border rounded text-xs font-medium leading-none placeholder-gray-800 text-gray-800 py-3 w-full pl-3 mt-2 h-32" placeholder="About Yourself ( max 300 words )"></textarea>
                                <p>Number of Charaters left: <span>300</span></p>
                            </div>
                        </div>


                        {/* Skills */}

                        <h2 className='mt-5 text-3xl font-semibold'> Skills</h2>

                        <div>
                            <div className="mt-6 w-full">
                                <label htmlFor="experties" className="text-sm font-medium leading-none text-gray-800">
                                    {" "}
                                    Experties{" "}
                                </label>
                                <input name="experties" id="experties" aria-labelledby="experties" type="text" className="bg-gray-200 border rounded text-xs font-medium leading-none placeholder-gray-800 text-gray-800 py-3 w-full pl-3 mt-2 " placeholder="e.g: HTML5 | CSS3 | Javascript | ES6 | REST API | REACT JS | FIREBASE | MONGODB " required />
                            </div>
                        </div>
                        <div>
                            <div className="mt-6 w-full">
                                <label htmlFor="comfortable" className="text-sm font-medium leading-none text-gray-800">
                                    {" "}
                                    Comfortable{" "}
                                </label>
                                <input name="comfortable" id="comfortable" aria-labelledby="comfortable" type="text" className="bg-gray-200 border rounded text-xs font-medium leading-none placeholder-gray-800 text-gray-800 py-3 w-full pl-3 mt-2 " placeholder="e.g: Node.js | Express.js | TypeScript | Redux | Next.js " required />
                            </div>
                        </div>
                        <div>
                            <div className="mt-6 w-full">
                                <label htmlFor="frameworks" className="text-sm font-medium leading-none text-gray-800">
                                    {" "}
                                    Frameworks{" "}
                                </label>
                                <input name="frameworks" id="frameworks" aria-labelledby="frameworks" type="text" className="bg-gray-200 border rounded text-xs font-medium leading-none placeholder-gray-800 text-gray-800 py-3 w-full pl-3 mt-2 " placeholder="e.g: Bootstrap | TailwindCSS | Daisy-UI | Material-UI " required />
                            </div>
                        </div>
                        <div>
                            <div className="mt-6 w-full">
                                <label htmlFor="toolsandsoftware" className="text-sm font-medium leading-none text-gray-800">
                                    {" "}
                                    Tools & Software{" "}
                                </label>
                                <input name="toolsandsoftware" id="toolsandsoftware" aria-labelledby="toolsandsoftware" type="text" className="bg-gray-200 border rounded text-xs font-medium leading-none placeholder-gray-800 text-gray-800 py-3 w-full pl-3 mt-2 " placeholder="e.g: VS Code | Git | Github | Figma | Vercel | Firebase | Netlify etc. " required />
                            </div>
                        </div>

                        {/* projects */}

                        <h2 className='mt-5 text-3xl font-semibold'> Projects</h2>



                        <div className='flex gap-10'>

                            <div className="mt-6 md:w-1/3">
                                <label htmlFor="projectname1" className="text-sm font-medium leading-none text-gray-800">
                                    {" "}
                                    Projects Name 1{" "}
                                </label>
                                <input name="projectname1" id="projectname1" aria-labelledby="projectname1" type="text" className="bg-gray-200 border rounded text-xs font-medium leading-none placeholder-gray-800 text-gray-800 py-3 w-full pl-3 mt-2 " placeholder="e.g: Doctor's Portal " required />
                            </div>


                            <div className="mt-6 md:w-1/3">
                                <label htmlFor="projectname2" className="text-sm font-medium leading-none text-gray-800">
                                    {" "}
                                    Projects Name 2{" "}
                                </label>
                                <input name="projectname2" id="projectname2" aria-labelledby="projectname2" type="text" className="bg-gray-200 border rounded text-xs font-medium leading-none placeholder-gray-800 text-gray-800 py-3 w-full pl-3 mt-2 " placeholder="e.g: Doctor's Portal " required />
                            </div>


                            <div className="mt-6 md:w-1/3">
                                <label htmlFor="projectname3" className="text-sm font-medium leading-none text-gray-800">
                                    {" "}
                                    Projects Name 3{" "}
                                </label>
                                <input name="projectname3" id="projectname3" aria-labelledby="projectname3" type="text" className="bg-gray-200 border rounded text-xs font-medium leading-none placeholder-gray-800 text-gray-800 py-3 w-full pl-3 mt-2 " placeholder="e.g: Doctor's Portal " required />
                            </div>

                        </div>




                        <div className='flex gap-10'>

                            <div className="mt-6 md:w-1/3">
                                <label htmlFor="projectspecification1" className="text-sm font-medium leading-none text-gray-800">
                                    {" "}
                                    What kind of Project{" "}
                                </label>
                                <input name="projectspecification1" id="projectspecification1" aria-labelledby="projectspecification1" type="text" className="bg-gray-200 border rounded text-xs font-medium leading-none placeholder-gray-800 text-gray-800 py-3 w-full pl-3 mt-2 " placeholder="e.g: Doctor's Portal " required />
                            </div>


                            <div className="mt-6 md:w-1/3">
                                <label htmlFor="projectspecification2" className="text-sm font-medium leading-none text-gray-800">
                                    {" "}
                                    What kind of Project{" "}
                                </label>
                                <input name="projectspecification2" id="projectspecification2" aria-labelledby="projectspecification2" type="text" className="bg-gray-200 border rounded text-xs font-medium leading-none placeholder-gray-800 text-gray-800 py-3 w-full pl-3 mt-2 " placeholder="e.g: Doctor's Portal " required />
                            </div>


                            <div className="mt-6 md:w-1/3">
                                <label htmlFor="projectspecification3" className="text-sm font-medium leading-none text-gray-800">
                                    {" "}
                                    What kind of Project{" "}
                                </label>
                                <input name="projectspecification3" id="projectspecification3" aria-labelledby="projectspecification3" type="text" className="bg-gray-200 border rounded text-xs font-medium leading-none placeholder-gray-800 text-gray-800 py-3 w-full pl-3 mt-2 " placeholder="e.g: Doctor's Portal " required />
                            </div>

                        </div>

                        {/* bullete point */}


                        <div className='flex gap-10'>

                            <div className="mt-6 md:w-1/3">
                                <label htmlFor="bulletepoint1" className="text-sm font-medium leading-none text-gray-800">
                                    {" "}
                                    Bullete Point 1.1{" "}
                                </label>
                                <input name="bulletepoint1" id="bulletepoint1" aria-labelledby="bulletepoint1" type="text" className="bg-gray-200 border rounded text-xs font-medium leading-none placeholder-gray-800 text-gray-800 py-3 w-full pl-3 mt-2 " placeholder="e.g: Used react.js, node.js, express.js, MongoDB, TailwindCSS, Javascript etc " required />
                            </div>


                            <div className="mt-6 md:w-1/3">
                                <label htmlFor="bulletepoint2" className="text-sm font-medium leading-none text-gray-800">
                                    {" "}
                                    Live Link{" "}
                                </label>
                                <input name="bulletepoint2" id="bulletepoint2" aria-labelledby="bulletepoint2" type="text" className="bg-gray-200 border rounded text-xs font-medium leading-none placeholder-gray-800 text-gray-800 py-3 w-full pl-3 mt-2 " placeholder="e.g: Used react.js, node.js, express.js, MongoDB, TailwindCSS, Javascript etc " required />
                            </div>


                            <div className="mt-6 md:w-1/3">
                                <label htmlFor="bulletepoint3" className="text-sm font-medium leading-none text-gray-800">
                                    {" "}
                                    Bullete Point 3.1{" "}
                                </label>
                                <input name="bulletepoint3" id="bulletepoint3" aria-labelledby="bulletepoint3" type="text" className="bg-gray-200 border rounded text-xs font-medium leading-none placeholder-gray-800 text-gray-800 py-3 w-full pl-3 mt-2 " placeholder="e.g: Used react.js, node.js, express.js, MongoDB, TailwindCSS, Javascript etc " required />
                            </div>

                        </div>


                        <div className='flex gap-10'>

                            <div className="mt-6 md:w-1/3">
                                <label htmlFor="bulletepoint11" className="text-sm font-medium leading-none text-gray-800">
                                    {" "}
                                    Bullete Point 1.2{" "}
                                </label>
                                <input name="bulletepoint11" id="bulletepoint11" aria-labelledby="bulletepoint1" type="text" className="bg-gray-200 border rounded text-xs font-medium leading-none placeholder-gray-800 text-gray-800 py-3 w-full pl-3 mt-2 " placeholder="e.g: User Authentication and Authorization System. " required />
                            </div>


                            <div className="mt-6 md:w-1/3">
                                <label htmlFor="bulletepoint22" className="text-sm font-medium leading-none text-gray-800">
                                    {" "}
                                    Bullete Point 2.2{" "}
                                </label>
                                <input name="bulletepoint22" id="bulletepoint22" aria-labelledby="bulletepoint22" type="text" className="bg-gray-200 border rounded text-xs font-medium leading-none placeholder-gray-800 text-gray-800 py-3 w-full pl-3 mt-2 " placeholder="e.g: User Authentication and Authorization System. " required />
                            </div>


                            <div className="mt-6 md:w-1/3">
                                <label htmlFor="bulletepoint33" className="text-sm font-medium leading-none text-gray-800">
                                    {" "}
                                    Bullete Point 3.2{" "}
                                </label>
                                <input name="bulletepoint33" id="bulletepoint33" aria-labelledby="bulletepoint33" type="text" className="bg-gray-200 border rounded text-xs font-medium leading-none placeholder-gray-800 text-gray-800 py-3 w-full pl-3 mt-2 " placeholder="e.g: User Authentication and Authorization System. " required />
                            </div>

                        </div>


                        <div className='flex gap-10'>

                            <div className="mt-6 md:w-1/3">
                                <label htmlFor="bulletepoint111" className="text-sm font-medium leading-none text-gray-800">
                                    {" "}
                                    Bullete Point 1.3{" "}
                                </label>
                                <input name="bulletepoint111" id="bulletepoint111" aria-labelledby="bulletepoint111" type="text" className="bg-gray-200 border rounded text-xs font-medium leading-none placeholder-gray-800 text-gray-800 py-3 w-full pl-3 mt-2 " placeholder="e.g: Used JWT, Context Api, React Query, CRUD, firebase, Custom Hocks " required />
                            </div>


                            <div className="mt-6 md:w-1/3">
                                <label htmlFor="bulletepoint222" className="text-sm font-medium leading-none text-gray-800">
                                    {" "}
                                    Bullete Point 2.3{" "}
                                </label>
                                <input name="bulletepoint222" id="bulletepoint222" aria-labelledby="bulletepoint222" type="text" className="bg-gray-200 border rounded text-xs font-medium leading-none placeholder-gray-800 text-gray-800 py-3 w-full pl-3 mt-2 " placeholder="e.g: Used JWT, Context Api, React Query, CRUD, firebase, Custom Hocks " required />
                            </div>


                            <div className="mt-6 md:w-1/3">
                                <label htmlFor="bulletepoint333" className="text-sm font-medium leading-none text-gray-800">
                                    {" "}
                                    Bullete Point 3.3{" "}
                                </label>
                                <input name="bulletepoint333" id="bulletepoint333" aria-labelledby="bulletepoint333" type="text" className="bg-gray-200 border rounded text-xs font-medium leading-none placeholder-gray-800 text-gray-800 py-3 w-full pl-3 mt-2 " placeholder="e.g: Used JWT, Context Api, React Query, CRUD, firebase, Custom Hocks " required />
                            </div>

                        </div>



                        {/* links */}


                        <div className='flex gap-10'>

                            <div className="mt-6 md:w-1/3">
                                <label htmlFor="livelink1" className="text-sm font-medium leading-none text-gray-800">
                                    {" "}
                                    Live Link{" "}
                                </label>
                                <input name="livelink1" id="livelink1" aria-labelledby="livelink1" type="text" className="bg-gray-200 border rounded text-xs font-medium leading-none placeholder-gray-800 text-gray-800 py-3 w-full pl-3 mt-2 " placeholder="e.g: https://doctor-s-portal-by-md-shijan.web.app/ " required />
                            </div>


                            <div className="mt-6 md:w-1/3">
                                <label htmlFor="livelink2" className="text-sm font-medium leading-none text-gray-800">
                                    {" "}
                                    Live Link{" "}
                                </label>
                                <input name="livelink2" id="livelink2" aria-labelledby="livelink2" type="text" className="bg-gray-200 border rounded text-xs font-medium leading-none placeholder-gray-800 text-gray-800 py-3 w-full pl-3 mt-2 " placeholder="e.g: https://doctor-s-portal-by-md-shijan.web.app/ " required />
                            </div>


                            <div className="mt-6 md:w-1/3">
                                <label htmlFor="livelink3" className="text-sm font-medium leading-none text-gray-800">
                                    {" "}
                                    Live Link{" "}
                                </label>
                                <input name="livelink3" id="livelink3" aria-labelledby="livelink3" type="text" className="bg-gray-200 border rounded text-xs font-medium leading-none placeholder-gray-800 text-gray-800 py-3 w-full pl-3 mt-2 " placeholder="e.g: https://doctor-s-portal-by-md-shijan.web.app/ " required />
                            </div>

                        </div>


                        <div className='flex gap-10'>

                            <div className="mt-6 md:w-1/3">
                                <label htmlFor="clientrepolink1" className="text-sm font-medium leading-none text-gray-800">
                                    {" "}
                                    Client Repository Link{" "}
                                </label>
                                <input name="clientrepolink1" id="clientrepolink1" aria-labelledby="clientrepolink1" type="text" className="bg-gray-200 border rounded text-xs font-medium leading-none placeholder-gray-800 text-gray-800 py-3 w-full pl-3 mt-2 " placeholder="e.g: https://github.com/freelancershijan/doctor-s-portal " required />
                            </div>


                            <div className="mt-6 md:w-1/3">
                                <label htmlFor="clientrepolink2" className="text-sm font-medium leading-none text-gray-800">
                                    {" "}
                                    Client Repository Link{" "}
                                </label>
                                <input name="clientrepolink2" id="clientrepolink2" aria-labelledby="clientrepolink2" type="text" className="bg-gray-200 border rounded text-xs font-medium leading-none placeholder-gray-800 text-gray-800 py-3 w-full pl-3 mt-2 " placeholder="e.g: https://github.com/freelancershijan/doctor-s-portal " required />
                            </div>


                            <div className="mt-6 md:w-1/3">
                                <label htmlFor="clientrepolink3" className="text-sm font-medium leading-none text-gray-800">
                                    {" "}
                                    Client Repository Link{" "}
                                </label>
                                <input name="clientrepolink3" id="clientrepolink3" aria-labelledby="clientrepolink3" type="text" className="bg-gray-200 border rounded text-xs font-medium leading-none placeholder-gray-800 text-gray-800 py-3 w-full pl-3 mt-2 " placeholder="e.g: https://github.com/freelancershijan/doctor-s-portal " required />
                            </div>

                        </div>


                        <div className='flex gap-10'>

                            <div className="mt-6 md:w-1/3">
                                <label htmlFor="serverrepositorylink1" className="text-sm font-medium leading-none text-gray-800">
                                    {" "}
                                    Server Repository Link{" "}
                                </label>
                                <input name="serverrepositorylink1" id="serverrepositorylink1" aria-labelledby="serverrepositorylink1" type="text" className="bg-gray-200 border rounded text-xs font-medium leading-none placeholder-gray-800 text-gray-800 py-3 w-full pl-3 mt-2 " placeholder="e.g: https://github.com/freelancershijan/doctor-s-portal " required />
                            </div>


                            <div className="mt-6 md:w-1/3">
                                <label htmlFor="serverrepositorylink2" className="text-sm font-medium leading-none text-gray-800">
                                    {" "}
                                    Server Repository Link{" "}
                                </label>
                                <input name="serverrepositorylink2" id="serverrepositorylink2" aria-labelledby="serverrepositorylink2" type="text" className="bg-gray-200 border rounded text-xs font-medium leading-none placeholder-gray-800 text-gray-800 py-3 w-full pl-3 mt-2 " placeholder="e.g: https://github.com/freelancershijan/doctor-s-portal " required />
                            </div>


                            <div className="mt-6 md:w-1/3">
                                <label htmlFor="serverrepositorylink3" className="text-sm font-medium leading-none text-gray-800">
                                    {" "}
                                    Server Repository Link{" "}
                                </label>
                                <input name="serverrepositorylink3" id="serverrepositorylink3" aria-labelledby="serverrepositorylink3" type="text" className="bg-gray-200 border rounded text-xs font-medium leading-none placeholder-gray-800 text-gray-800 py-3 w-full pl-3 mt-2 " placeholder="e.g: https://github.com/freelancershijan/doctor-s-portal " required />
                            </div>

                        </div>


                        {/* language */}



                        <div className='flex gap-10'>
                            <div className="mt-6 md:w-1/2">
                                <label htmlFor="language1" className="text-sm font-medium leading-none text-gray-800">
                                    {" "}
                                    Language{" "}
                                </label>
                                <input name="language1" id="language1" aria-labelledby="language1" type="text" className="bg-gray-200 border rounded text-xs font-medium leading-none placeholder-gray-800 text-gray-800 py-3 w-full pl-3 mt-2 " placeholder="e.g: bangla " required />
                            </div>

                            <div className="mt-6 w-1/2">
                                <label htmlFor="languageexpert1" className="text-sm font-medium leading-none text-gray-800">
                                    {" "}
                                    Status {" "}
                                </label>
                                <input name='languageexpert1' id="languageexpert1" aria-labelledby="languageexpert1" type="text" className="bg-gray-200 border rounded text-xs font-medium leading-none placeholder-gray-800 text-gray-800 py-3 w-full pl-3 mt-2" placeholder="e.g: Fluent " required />
                            </div>


                        </div>


                        <div className='flex gap-10'>
                            <div className="mt-6 md:w-1/2">
                                <label htmlFor="language2" className="text-sm font-medium leading-none text-gray-800">
                                    {" "}
                                    Language {" "}
                                </label>
                                <input name="language2" id="language2" aria-labelledby="language2" type="text" className="bg-gray-200 border rounded text-xs font-medium leading-none placeholder-gray-800 text-gray-800 py-3 w-full pl-3 mt-2 " placeholder="e.g: English " required />
                            </div>

                            <div className="mt-6 w-1/2">
                                <label htmlFor="languageexpert2" className="text-sm font-medium leading-none text-gray-800">
                                    {" "}
                                    Status {" "}
                                </label>
                                <input name='languageexpert2' id="languageexpert2" aria-labelledby="languageexpert2" type="text" className="bg-gray-200 border rounded text-xs font-medium leading-none placeholder-gray-800 text-gray-800 py-3 w-full pl-3 mt-2" placeholder="e.g: Conventional " required />
                            </div>


                        </div>






                        <div className="mt-8">
                            <button role="button" className="focus:ring-2 focus:ring-offset-2 focus:ring-indigo-700 text-sm font-semibold leading-none text-white focus:outline-none bg-indigo-700 border rounded hover:bg-indigo-600 py-4 w-full">
                                Create my Resume
                            </button>
                        </div>
                    </div>

                </form>
            </div>
        </div>
    );
};

export default CreateResume;